import { render, staticRenderFns } from "./AskAQuestionAttachmentImagePreview.vue?vue&type=template&id=2c9e7c22&scoped=true"
import script from "./AskAQuestionAttachmentImagePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./AskAQuestionAttachmentImagePreview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AskAQuestionAttachmentImagePreview.vue?vue&type=style&index=0&id=2c9e7c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e7c22",
  null
  
)

export default component.exports